import React, { ReactNode, useState } from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import ScheduleDateTimePickerDialog from '../../../Shared/ScheduleDateTimePickerDialog';

type SchedulePostDateTimeDialogProps = {
  disabled?: boolean;
  value: Date;
  onChange: (date: Date) => void | Promise<void>;
  renderTrigger: () => ReactNode;
};

const SchedulePostDateTimeDialog = ({
  disabled = false,
  value,
  onChange,
  renderTrigger,
}: SchedulePostDateTimeDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        sx={{ display: 'inline-flex' }}
        onClick={disabled ? undefined : () => setOpen(true)}
      >
        {renderTrigger()}
      </Box>
      <ScheduleDateTimePickerDialog
        open={open}
        value={value}
        onClose={() => setOpen(false)}
        onConfirm={onChange}
      />
    </>
  );
};

export default SchedulePostDateTimeDialog;
